import { SponsorTabKeyType } from '../Types'

export const getTabLabel = (tab: SponsorTabKeyType) => {
  switch (tab) {
    case SponsorTabKeyType.DETAILS:
      return 'Details tab'
    case SponsorTabKeyType.REPS:
      return 'Profile tab'
    case SponsorTabKeyType.PRODUCTS:
      return 'Products'
    case SponsorTabKeyType.DOWNLOADS:
      return 'Downloads'
    default:
  }
}

/**
 * Returns the size of a base64 encoded image in bytes, kilobytes, and megabytes.
 * @param {string} base64String - The base64 encoded image string.
 * @returns {Object} An object containing the size in bytes, kilobytes, and megabytes.
 */
export function getFileSizeFromBase64(base64String: string) {
  if (typeof base64String !== 'string' || !base64String.startsWith('data:') || !base64String.includes(';base64,')) {
    return null
  }

  // Remove the prefix
  const base64WithoutPrefix = base64String.split(',')[1] || base64String

  // Remove padding (=) characters
  const cleanedBase64 = base64WithoutPrefix.replace(/=+$/, '')

  const sizeInBytes = (cleanedBase64.length * 3) / 4
  const sizeInKB = sizeInBytes / 1024
  const sizeInMB = sizeInKB / 1024

  return {
    sizeInBytes,
    sizeInKB,
    sizeInMB
  }
}
